import { inject, provide, type App } from 'vue'
import { useEsimStore } from '~/stores/esimStore'

export type WidgetMode = 'default' | 'search' | 'steps' | 'checkout' | 'affiliate'

export type WidgetModeOpt = Partial<{
  mode: WidgetMode
  instanceId: string
  domain?: string
  allowStripe?: boolean
}>

const KEY = Symbol('useWidgetMode')

const getWithDefaults = (opt: WidgetModeOpt = {}) => {
  const { mode = 'default', instanceId = mode, domain = '', allowStripe = false } = opt
  return { mode, instanceId, domain, allowStripe }
}

export const useWidgetMode = () => {
  return inject(KEY, getWithDefaults())
}

useWidgetMode.provide = (opt: WidgetModeOpt = {}, app?: App) => {
  const value = getWithDefaults(opt)
  app ? app.provide(KEY, value) : provide(KEY, value)
}

export const useStore = () => {
  const { instanceId, domain } = useWidgetMode()
  return useEsimStore(instanceId, domain)
}